
const formatLocation = (location?: string) => {
    const formattedLocation = location?.replace(/, (?=$)/, '')?.replace(/, (?=$)/, '')
    return formattedLocation
}

export default formatLocation